'use strict';

const config = {
    voterSelector: '.js-voter',
    voterArrowSelector: '.js-voter__button',
    voterCountSelector: '.js-voter__count',
    voterArrowSelectedClass: 'c-voter__arrow--selected'
}

$(config.voterSelector).on('click', config.voterArrowSelector, function(e) {
    e.preventDefault();

    const arrow = $(this);
    const voter = arrow.closest(config.voterSelector);

    const activeArrow = voter.find(`.${config.voterArrowSelectedClass}`).first();
    if (activeArrow.length > 0 && !arrow.is(activeArrow)) {
        updateVote(activeArrow, voter, false);
    }

    updateVote(arrow, voter);

    arrow.blur();
});

function updateVote(arrow, voter, sendXhr = true) {
    let modifier = 0;
    let totalCount = 0;

    if (arrow.data('direction') === 'up') {
        modifier = modifier + 1;
    } else if (arrow.data('direction') === 'down') {
        modifier = modifier -1;
    } else {
        return ; // User didn't click on up or down. We don't know what to do here so bail
    }

    // We are undoing our decision so reverse the modifier
    if (arrow.hasClass(config.voterArrowSelectedClass)) {
        modifier = modifier * -1;
        arrow.removeClass(config.voterArrowSelectedClass);
    } else {
        arrow.addClass(config.voterArrowSelectedClass);
    }

    // Increment the number
    const count = voter.find(config.voterCountSelector);
    const countVal = parseInt(count[0].innerHTML, 10);

    totalCount = countVal + modifier;
    count.text(Math.max(0, totalCount));

    // If we are changing our vote then don't send a request. the app will handle this
    if (sendXhr) {
        return $.post(arrow.attr('href'));
    }
}



// WEBPACK FOOTER //
// ./src/js/components/voter.js